import http from '@admin/http';
import { AxiosInstance } from 'axios';

export function blockAccountCtor(http: AxiosInstance) {
  return async (id: string) => http.put(`/lnpl/v1/delinquent-loan-orders/${id}/block-account`);
}

export const blockAccount = blockAccountCtor(http);
